<template>
  <div
    class="flex justify-between items-center w-$portalContainerWidth mx-auto"
    :style="{ height: `${height}px` }"
    v-if="height"
  >
    <div class="pl-20px">
      <img
        class="h-1/2 cursor-pointer"
        :src="getLogo()"
        alt=""
        @click="$router.push(`${routerBase}/integration/portal/homepage`)"
        v-if="logo"
      />
    </div>
    <div class="flex-1 px-20px h-1/2" v-if="setting.topStyle === 1">
      <img class="h-full cursor-pointer w-full" :src="`${fileUrl}${setting.logo}`" alt="" />
    </div>
    <div class="flex items-center">
      <!-- <el-button class="mr-10px" size="small" @click="toBIM">数字工程</el-button>
      <el-button class="mr-10px" size="small" @click="toCockpit">智慧企业</el-button>
      <el-button class="mr-10px" size="small" @click="toAppCenter">应用中心</el-button>
      <el-button class="mr-10px" size="small" @click="toWorkBench" v-if="userInfo"
        >工作台</el-button
      > -->
      <template v-if="setting.topStyle !== 1">
        <template v-for="(item, index) in navigation">
          <div
            class="text-14px font-bold h-14px flex items-center"
            :key="index"
            v-if="item.jumpType === 0 || item.jumpSource.startsWith('http') || userInfo"
          >
            <span class="mx-16px cursor-pointer" @click="jump(item)">{{ item.name }}</span>
            <span
              v-if="index !== navigation.length - 1"
              class="w-2px h-full bg-$portalPrimaryColor rounded-1px"
            ></span>
          </div>
        </template>
      </template>
      <div v-if="!userInfo" class="mr-20px">
        <span
          class="w-2px h-full bg-$portalPrimaryColor rounded-1px inline-block h-14px mr-14px"
        ></span>
        <el-button type="primary" size="small" @click="toLogin">
          统一登录
        </el-button>
      </div>
      <el-input
        class="w-180px focus:border-$portalPrimaryColor"
        placeholder="请输入关键字搜索"
        prefix-icon="el-icon-search"
        clearable
        v-model="keyWord"
        @input="search"
        v-if="setting.showSearch !== 0"
      >
      </el-input>
      <div
        class="relative mr-20px ml-20px"
        @click="$router.push(`${routerBase}/integration/portal/workbench`)"
        v-if="userInfo"
      >
        <div
          class="bg-$portalPrimaryColor w-6px h-6px rounded-1/2 absolute right-0"
          v-if="haveTodo"
        ></div>
        <img
          class="cursor-pointer w-20px h-20px max-w-none"
          src="@/assets/images/消息中心.png"
          alt=""
        />
      </div>
      <img class="mr-3px h-28px w-28px rounded-1/2" :src="userPic" alt="" v-if="userInfo" />
      <el-dropdown class=" overflow-visible" v-if="userInfo">
        <div class="flex items-center text-hex-333">
          <span class="el-dropdown-link inline-block max-w-55px truncate">
            {{ userInfo.profile.given_name }}
          </span>
          <i class="el-icon-caret-bottom"></i>
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            command="1"
            @click.native="toBackground('/system-management/personal-center')"
            >个人中心</el-dropdown-item
          >
          <el-dropdown-item
            command="2"
            @click.native="
              toBackground('/portal-management/information-publish/column-publish-application')
            "
            >门户管理</el-dropdown-item
          >
          <el-dropdown-item command="3" @click.native="logout">退出登录</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <AddSSOConfig @save="ssoSave" :appConfig="appConfig" ref="addSSOConfig" />
  </div>
</template>

<script>
import { WorkbenchSettingApi, SingleSignOnApi } from '@wiz-api/workbench-std'
import { EafLoginApi } from '@wiz-api/auth-server'
import { DataCategoryApi } from '@wiz-api/data-category-management'
import { TodoApi } from '@wiz-api/todo-management'
import AddSSOConfig from './AddSSOConfig'
import { getFieldValue, ssoLogin } from '../js/sso'

const workbenchSettingApi = new WorkbenchSettingApi()
const singleSignOnApi = new SingleSignOnApi()
const eafLoginApi = new EafLoginApi()

const todoApi = new TodoApi()
const dataCategoryApi = new DataCategoryApi()
const { config } = Wiz.globalSettings.dynamicModules.modules['portal-homepage-std']
export default {
  name: 'portalHeader',
  components: {
    AddSSOConfig,
  },
  props: {
    logo: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      keyWord: '',
      height: 0,
      navigation: [],
      userInfo: null,
      haveTodo: false,
      appSettings: [],
      appConfig: {},
      todoStatus: [],
      setting: {},
    }
  },
  watch: {},
  methods: {
    search(value) {
      this.$router.push({
        path: `${this.routerBase}/integration/portal/search`,
        query: {
          text: value,
        },
      })
    },
    toLogin() {
      if (window.__POWERED_BY_QIANKUN__) {
        this.$router.push({
          path: '/login',
          query: {
            redirect: this.$route.fullPath,
          },
        })
      } else if (config?.fromDiyCode) {
        window.location.href = `${
          Wiz.globalSettings?.globalConfig?.diyCodePage
        }/#/login?redirect=${encodeURIComponent(window.location.href)}`
      } else {
        // 退出登录还原默认icon title
        document.querySelector("link[rel='icon']").href = require('../image/favicon.png')
        document.title = 'Wiz Saas'
        this.$router.push({
          path: Wiz.globalSettings?.auth?.defaultLoginPath,
          query: {
            returnUrl: this.$route.fullPath,
          },
        })
      }
    },
    toBackground(path) {
      if (config?.fromDiyCode) {
        const routerBase = `/${_.get(Wiz, 'globalSettings.globalConfig.routerBase')}`
        window.location.href = `${Wiz.globalSettings?.globalConfig?.diyCodePage}/#${routerBase}${path}`
      } else {
        this.$router.push(`${this.routerBase}${path}`)
      }
    },

    jump(item) {
      if (item.jumpType === 0) {
        const app = _.find(this.appSettings, { id: item.jumpSource })
        if (!app) {
          this.$message.warning('应用不存在')
          return
        }
        this.toApp(app)
        return
      }
      const url = item.jumpSource
      // 当前项目模块
      if (item.jumpSource.startsWith(window.location.origin)) {
        if (!this.userInfo) {
          // 跳转登录再做重定向
          window.open(
            `${
              Wiz.globalSettings?.globalConfig?.diyCodePage
            }/#/login?redirect=${item.jumpSource.replace(window.location.origin, '')}`
          )
          return
        }
      }
      if (item.jumpSource.startsWith('http')) {
        window.open(url)
      } else {
        this.$router.push(`${this.routerBase}${url}`)
      }
    },
    async toApp(app) {
      if (!this.userInfo) {
        window.open(app.loginUrl)
        return
      }
      // 0:直接跳转 3：auth2.0
      if (app.loginType === 0) {
        const loginParams = app.moreParamSetting ? JSON.parse(app.moreParamSetting) : []
        let url = ''
        _.forEach(loginParams, (item) => {
          if (item.postType === 'url') {
            url += `&${item.fieldsName}=${getFieldValue(item)}`
          }
        })
        window.open(`${app.loginUrl}${url ? url.replace('&', '?') : ''}`)
      } else if (app.loginType === 3) {
        const [err, res] = await eafLoginApi.takeOidcCode(
          'SSO_APP',
          app.loginUrl,
          'code',
          'openid profile'
        )
        if (!err) {
          if (res.isSuccess) {
            const loginParams = app.moreParamSetting ? JSON.parse(app.moreParamSetting) : []
            let url = ''
            _.forEach(loginParams, (item) => {
              if (item.postType === 'url') {
                url += `&${item.fieldsName}=${getFieldValue(item)}`
              }
            })
            url += `&code=${res.code}`
            window.open(`${app.loginUrl}${url ? url.replace('&', '?') : ''}`)
          } else {
            this.$message.error(res.errorMessage)
          }
        }
      } else {
        const [err, res] = await singleSignOnApi.getAppssoParamsDetail({
          userId: this.userInfo?.profile?.sub,
          appId: app.id,
        })
        if (!err) {
          if (res.id !== '00000000-0000-0000-0000-000000000000') {
            ssoLogin(app, res)
          } else {
            this.appConfig = app
            this.$refs.addSSOConfig.dialogVisible = true
          }
        }
      }
    },
    ssoSave(data) {
      ssoLogin(this.appConfig, data)
    },
    logout() {
      const currentTheme = this.$store.getters['System/currentTheme']
      const accountInfo = localStorage.getItem('accountInfo')
      localStorage.clear()
      const vuexModules = ['Auth', 'System', 'Abp', 'Sites']
      vuexModules.forEach((item) => {
        this.$store.commit(`${item}/resetState`)
      })
      // 退出清空缓存后设置当前主题缓存 保证登录页主题显示正常
      this.$store.dispatch('System/currentTheme', currentTheme)
      if (accountInfo) {
        localStorage.setItem('accountInfo', accountInfo)
      }
      this.userInfo = null
      this.$router.replace(`${this.routerBase}/integration/portal/homepage`)
    },
    getLogo() {
      if (!this.logo) {
        return ''
      }
      return this.fileUrl + this.logo
    },
    async getDictionary() {
      const [err, res] = await dataCategoryApi.getByCode({
        code: 'TodoStatus',
        includeDetails: true,
      })
      if (!err && !_.isEmpty(res)) {
        this.todoStatus = res.dataItems
      }
    },
    async getTodo() {
      const [err, res] = await todoApi.todoQueryPaged({
        status: _.find(this.todoStatus, (item) => {
          return item.displayName === '待办'
        })?.id,
        userId: this.userInfo?.profile?.sub,
        skipCount: 0,
        maxResultCount: 1,
      })
      if (!err) {
        this.haveTodo = res.items.length > 0
      }
    },
    async getTopMenuSettings() {
      const [err, res] = await workbenchSettingApi.getWorkbenchSetting({ code: 'topMenu' })
      if (!err && res && res.config) {
        this.setting = JSON.parse(res.config)
        this.navigation = this.setting.menus
        this.height = this.setting.height || 60
        this.$emit('heightChange', this.height)
        const appIds = _.map(
          _.filter(this.navigation, (item) => {
            return item.jumpType === 0
          }),
          'jumpSource'
        )
        this.getAppSettings(appIds)
      }
    },
    async getAppSettings(ids) {
      if (_.isEmpty(ids)) return
      const [err, res] = await singleSignOnApi.getAppssoSettingByIds({
        ids,
      })
      if (!err) {
        this.appSettings = res
      }
    },
  },
  created() {
    this.getTopMenuSettings()
  },
  async mounted() {
    this.userInfo = Wiz.AuthHooks.GetUserInfo()
    if (this.userInfo) {
      await this.getDictionary()
      await this.getTodo()
    }
  },
  computed: {
    routerBase() {
      if (window.__POWERED_BY_QIANKUN__) {
        return `/${_.get(Wiz, 'globalSettings.globalConfig.routerBase')}`
      }
      return ''
    },
    fileUrl() {
      const fileServer = Wiz.GetModuleServer('file-management')
      return `${fileServer}/api/file-management/files/public/image/`
    },
    AvatarUrl() {
      if (window.__POWERED_BY_QIANKUN__ || config?.fromDiyCode) {
        return _.get(Wiz, 'globalSettings.globalConfig.diyCodeMediaServer')
      }
      return this.fileUrl
    },
    userPic() {
      const avatar = this.userInfo?.profile?.avatar
      if (avatar) {
        return `${this.AvatarUrl}${avatar}`
      }
      const gender = this.userInfo?.profile?.gender || '1'
      return require(`../image/avatar${gender}.png`)
    },
  },
}
</script>

<style lang="scss" scoped></style>
